import store from '@/store';

export const isAuthenticated = (to, from, next) => {
  if (store.getters['user/isAuthenticated']) {
    next();
    return;
  }
  next('/login');
};

export const isNotAuthenticated = (to, from, next) => {
  if (!store.getters['user/isAuthenticated']) {
    next();
    return;
  }
  next('/');
};
